<script>
  import _ from 'lodash';
  import {onMount, createEventDispatcher, onDestroy, tick} from 'svelte';
  import {writable} from 'svelte/store';
  import {firebaseUser} from '../auth/authStore';
  import firebase from 'firebase';
  import {editingMessageId, uploadImages} from "./messageStore";
  import {promiseTimeout} from "../lib/timeout";

  export let channelId;
  export let messageId = null; // for comment
  export let disabled = false;

  const isIos = window.navigator.userAgent.includes('iPhone') || window.navigator.userAgent.includes('iPad');

  const dispatch = createEventDispatcher();

  let inputElement;
  let body = '';
  let selectedImageFile = null;

  onMount(() => {
    inputElement && inputElement.focus();
  });

  const onSubmit = e => {
    if (disabled) return;
    e && e.preventDefault();

    const inputValue = inputElement.innerText.trim();

    if (!inputValue && !selectedImageFile) return;

    const newMessage = firebase.firestore().collection('messages').doc();

    newMessage.set({
      channelId,
      messageId,
      userId: $firebaseUser.uid,
      body: inputValue,
      type: messageId ? 'comment' : 'message',
      created: firebase.firestore.FieldValue.serverTimestamp(),
      modified: firebase.firestore.FieldValue.serverTimestamp()
    });

    if (selectedImageFile) {
      uploadImages(newMessage.id, [selectedImageFile]);
    }
    inputElement.innerHTML = '';
    selectedImageFile = null;
    inputElement.focus();
  };


  const onKeyPress = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  const onKeyDown = e => {
    // ArrowUp doesn't work in onKeyPress
    if (!inputElement.innerText.trim() && e.key === 'ArrowUp') {
      dispatch('editlastmessage');
    }
  };

  const onSelectFile = e => {
    if (_.isEmpty(e.target.files)) return;
    selectedImageFile = e.target.files[0];
    inputElement.focus();
  };

  const unselectFile = () => selectedImageFile = null;

  const channelIdStore = writable(channelId);
  $: channelIdStore.set(channelId);
  const unsubscribeChannelId = channelIdStore.subscribe(async val => {

    // don't focus for mobile devices
    if (isIos) return;

    // message form is being submitted automatically when quick search with Korean
    await promiseTimeout(500);

    inputElement && inputElement.focus();
  });

  const unsubscribeEditingMessageId = editingMessageId.subscribe(val => {
    if (!val) {
      inputElement && inputElement.focus();
    }
  });

  onDestroy(() => {
    unsubscribeChannelId();
    unsubscribeEditingMessageId();
  });

</script>


<form class="column" on:submit={onSubmit} class:disabled={disabled}>
  {#if selectedImageFile}
    <div class="selected-image" style="background-image: url('{URL.createObjectURL(selectedImageFile)}')" on:click={unselectFile}>
      <button type="button">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
  {/if}


  <row align-center>
    <label class="column center">
      <ion-icon name="image-outline"></ion-icon>
      <input on:change={onSelectFile} type="file" style="position: absolute; opacity: 0; pointer-events: none;" accept="image/*">
    </label>
    <div class="input expand" contenteditable bind:this={inputElement} on:keypress={onKeyPress} on:keydown={onKeyDown}></div>
    <button type="submit">
      <ion-icon name="paper-plane-outline"></ion-icon>
    </button>
  </row>

</form>

<style>
  form {
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 8px;
    transition: opacity .3s;
  }

  form.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  ion-icon {
    font-size: 20px;
    color: #555;
    vertical-align: middle;
  }

  .input {
    line-height: 1.5em;
    max-height: 300px;
    overflow-y: auto;
  }

  button, label {
    border: none;
    height: 32px;
    text-align: center;
    width: 40px;
    padding: 0;
    background: none;
    align-self: flex-end;
  }

  .selected-image {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    background-position: center;
    background-size: cover;
    position: relative;
    margin: 12px 12px 8px;

  }
  .selected-image button {
    position: absolute;
    background-color: black;
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    right: -8px;
    top: -8px;
  }

</style>